<template>
  <div>
    <h1>page2</h1>
    <button @click="toPage1">toPage1</button>
  </div>
</template>

<script>
export default {
  mounted() {
    // window.toPage1 = function() {
    //   this.$router.push('/page1');
    // };
    this.$jsBridge.callHandler("dispatchBackBtn");
    this.$jsBridge.registerhandler("onBackPressed", () => {
      this.$router.push("/page1");
    });
  },
  methods: {
    toPage1() {
      this.$router.push("/page1");
    },
  },
  created() {
    console.log(this.$route);
  },
};
</script>

<style></style>
